// extracted by mini-css-extract-plugin
export default {"cancelLink":"dd69663fd220"};